<template>
    <article
        v-if="show"
        class="message-form-alert"
        :class="classes"
        :style="styles"
        @click="onClick"
    >
        <div class="message" :class="type">
            <div class="message-body">
                <fa-icon v-if="icon" :icon="icon" />
                <template v-if="isSlot">
                    <slot v-if="useClearSlot" />
                    <span v-else>
                        <slot />
                    </span>
                </template>
                <template v-else>
                    <span v-if="isHtml" v-html="message" />
                    <span v-else v-text="message" />
                </template>
            </div>
        </div>
    </article>
</template>

<script>
export default {
    props: {
        isHtml: { type: Boolean, default: false },
        type: { type: String, default: 'is-warning' },
        icon: { type: [String, Boolean], default: 'exclamation-triangle' },
        message: { type: String, default: '' },
        classes: { type: String, default: '' },
        link: { type: String, default: '' },
        useClearSlot: { type: Boolean, default: false },
    },

    computed: {
        show() {
            return Boolean(this.message || this.isSlot);
        },

        isSlot() {
            return Object.keys(this.$slots).length;
        },

        styles() {
            return {
                ...(this.link ? { cursor: 'pointer' } : null),
            };
        },
    },

    methods: {
        onClick() {
            if (this.link) {
                this.$router.push(this.link);

                return;
            }
        },
    },
};
</script>
